<template>
  <Layout
    :errors="errors"
    :title="trans(`models.${resourceType}.content.show.action`)"
    :toasts="toasts"
    :background="model.data ? 'url(\'' + model.data.attributes.background_url + '\')' : 'none'"
    :resource="model"
  >
    <div v-if="model.data" class="card shadow rounded-corner mb-3">
      <div class="card-body">
        <div class="video-container">
          <iframe :src="model.data.attributes.url" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px;max-height: calc(100vh - var(--forgeron-header-height));"></iframe>
        </div>
        <div class="model-title-bar">
          <div class="flex row pe-2">
            <div class="col flex-grow-1 pt-3">
              <h2 class="card-title text-primary fw-bold text-uppercase mb-0">
                {{ model.data.attributes.title }}
              </h2>
              <h3>{{ model.data.attributes.subtitle }}</h3>
            </div>
            <div class="col flex-grow-0 social-media pt-3">
              <div class="share">Teilen</div>
              <div class="buttons d-flex mt-2">
                <a :href="'https://www.facebook.com/share.php?u=' + route(route().current(), route().params)" class="fb px-1" target="_blank">
                  <img src="/img/fb.png" alt="Share on Facebook" title="Share on Facebook">
                </a>
<!--                <a :href="'https://twitter.com/share?url=' + route(route().current(), route().params)" class="twitter px-1" target="_blank">-->
<!--                  <img src="https://www.nordsehen.tv/wp-content/themes/ntv/img/twitter.png" alt="Share on Twitter" title="Share on Twitter">-->
<!--                </a>-->
                <a :href="'mailto:?subject=' + model.data.attributes.title + '&amp;body=' + route(route().current(), route().params)" class="mail px-1" target="_blank">
                  <img src="/img/email.png" alt="Write E-Mail" title="Write E-Mail">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-content>
      <div class="header-links pt-1">
        <Link :href="route(`${routePrefix}.video-categories.show`, { video_category: $page.props.featuredCategory.id })">
          <button class="btn btn-tertiary m-2" type="button">{{ $page.props.featuredCategory.title }}</button>
          <i class="fa-solid fa-circle-chevron-right m-2"></i>
        </Link>
      </div>
      <div class="header-links pt-1" v-if="model.data.attributes.category_id">
        <Link :href="route(`${routePrefix}.videos.index`, { filter: { category_id: model.data.attributes.category_id } })">
          <button class="btn btn-tertiary m-2" type="button">{{ model.data.relations.category.data.attributes.model_title }}</button>
          <i class="fa-solid fa-circle-chevron-right m-2"></i>
        </Link>
      </div>
    </footer-content>
  </Layout>
</template>

<script>
import Card from '@/structures/default/components/Base/Card';
import FooterContent from '@/structures/moviary/components/Custom/FooterContent';
import MediaCollection from '@/structures/default/components/Presentation/MediaCollection.vue';
import ResourceActionButtons from '@/structures/default/components/Links/ResourceActionButtons';
import ResourceList from '@/structures/default/components/Collection/ResourceList';
import { ref } from 'vue';
import { Link } from '@inertiajs/vue3';
import Layout from "@/structures/moviary/Pages/Layout";

export default {
  components: {
    Card,
    FooterContent,
    Layout,
    Link,
    MediaCollection,
    ResourceActionButtons,
    ResourceList,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    resourceType: { type: String, default: '' },
    sort: { type: String, default: 'id' },
    filter: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  emits: ['addToast'],
  setup(props) {
    const localModel = ref(props.model);

    return {
      localModel,
    };
  },
};
</script>
